document.addEventListener('DOMContentLoaded', function () {

	const toggleBtns = document.querySelectorAll('.menu-toggle');
	const closeBtns = document.querySelectorAll('.menu-close');
	const fullscreenMenu = document.querySelector('.fullscreen-menu');

	const toggleButton = document.querySelector('.site-header__menu-toggle.menu-phone-toggle');
	const phonesDiv = document.querySelector('.header__phones');

	toggleButton.addEventListener('click', function () {
		phonesDiv.classList.toggle('is-visible');
	});

	toggleBtns.forEach(btn => {
		btn.addEventListener('click', () => {
			fullscreenMenu.classList.add('active');
			document.body.classList.add('no-scroll');
		});
	});

	closeBtns.forEach(btn => {
		btn.addEventListener('click', () => {
			fullscreenMenu.classList.remove('active');
			document.body.classList.remove('no-scroll');
			phonesDiv.classList.remove('is-visible');
		});
	});


	const headers = document.querySelectorAll('.fullscreen-menu__content-bottom .header-section__title');

	headers.forEach(header => {
		const section = header.closest('.header-section');
		const menuContainer = section.querySelector('.header-section__list');

		if (menuContainer) {
			menuContainer.classList.add('header-section__list-is-hidden');
			header.classList.remove('is-open');

			header.addEventListener('click', () => {
				const isHidden = menuContainer.classList.toggle('header-section__list-is-hidden');
				header.classList.toggle('is-open', !isHidden);
			});
		}
	});


});
